// The direct-sales register (superadmin token).
//
// Reading is one endpoint; WRITING goes to each record's own home — a
// supervisor note is fixed through saleRemindersApi, a counter sale through
// counterApi (opsApi.js) — so the register never grows write paths of its own.
import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

export const saleNotesApi = {
  /** ?period=all|today|yesterday|7d|30d · ?from=&to= · ?kind= · ?status= · ?q= */
  list: (params = {}) => axiosInstance.get(API_ENDPOINTS.SALE_NOTES.LIST, { params }),
};
